import { useEffect } from 'react';
import { Security } from '@okta/okta-react';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { setEnvContext } from 'flowhawk-core';

import ErrorBoundary from '../Containers/ErrorBoundary';
import ErrorLogger from '../Components/ErrorLogger';
import { Outlet, useNavigate } from '@tanstack/react-router';
import { useDispatch } from 'react-redux';
import { useTrackScreenBreakpoint } from '../Hooks/useScreenWidth';

function Routes() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useTrackScreenBreakpoint();

  let oktaAuth: OktaAuth | null = null;
  if (import.meta.env.VITE_SPA_DOMAIN) {
    oktaAuth = new OktaAuth({
      issuer: import.meta.env.VITE_SPA_DOMAIN || '',
      clientId: import.meta.env.VITE_SPA_CLIENT_ID || '',
      redirectUri: `${window.location.origin}/login/callback`,
    });
  }

  useEffect(() => {
    dispatch(
      setEnvContext({
        API_DOMAIN: import.meta.env.VITE_API_DOMAIN || '',
        API_ROOT: import.meta.env.VITE_API_ROOT || '',
        API_KEY: import.meta.env.VITE_API_KEY || '',
        locale: { countryCode: 'US', languageTag: 'en-US', languageCode: 'en' },
      }),
    );
  }, []);

  const restoreOriginalUri = (originalUri: string) => {
    navigate({ to: toRelativeUrl(originalUri || '/login/sso-login', window.location.origin), replace: true });
  };

  const customAuthHandler = () => {
    navigate({ to: '/login' });
  };

  return (
    <ErrorBoundary>
      <ErrorLogger />
      {import.meta.env.VITE_SPA_CLIENT_ID && oktaAuth ? (
        <Security
          oktaAuth={oktaAuth}
          restoreOriginalUri={(_oktaAuth, originalUri) => {
            restoreOriginalUri(originalUri);
          }}
          onAuthRequired={() => {
            customAuthHandler();
          }}
        >
          {/* <Switch>
              <Route path="/login/callback" component={LoginCallback} />
              <Route path="/login/sso-login" component={SSOLoginHandler} />
              <Route path="/reset-password" component={ResetExpiredPasswordPage} />
              <Route path="/login" component={LoginPage} />
              <Route path="/register" component={RegistrationPage} />
              <Route path="/chat" component={ChatPage} />
              <Route path="*" component={LoginPage} />
            </Switch> */}
          <Outlet />
        </Security>
      ) : (
        <Outlet />
      )}
    </ErrorBoundary>
  );
}

export default Routes;
